import { PosterProduct } from "@/domain/entities/CreateBookingV3";

export function applyRecommendationOrder(
  listProduct: string[],
  upsellingData: PosterProduct[]
): string[] {
  const findUpselling = (type: string): PosterProduct | undefined =>
    upsellingData.find(
      (item) => item.productType.toLowerCase() === type.toLowerCase()
    );

  const recommended: string[] = [];
  const rest: string[] = [];

  for (const type of listProduct) {
    const item = findUpselling(type);
    if (item?.isRecommended) {
      recommended.push(type);
    } else {
      rest.push(type);
    }
  }

  if (recommended.length === 0) return [...listProduct];

  const tarifPembanding = (type: string): number => {
    const item = findUpselling(type);
    if (!item) return 0;
    return (item.publishRate ?? 0) + (item.shippingSurchargeRate ?? 0) + (item.forwardRates ?? 0);
  };

  recommended.sort((a, b) => tarifPembanding(a) - tarifPembanding(b));

  return [...recommended, ...rest];
}
